module.exports = __webpack_public_path__ + "img/drawer.10048bae.svg";